import { render, staticRenderFns } from "./review-questions.vue?vue&type=template&id=52e5325c&scoped=true&"
import script from "./review-questions.vue?vue&type=script&lang=js&"
export * from "./review-questions.vue?vue&type=script&lang=js&"
import style0 from "./review-questions.vue?vue&type=style&index=0&id=52e5325c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e5325c",
  null
  
)

component.options.__file = "review-questions.vue"
export default component.exports